import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] py-16 px-8 md:px-16">
      <div className="w-full">
        {/* Top row */}
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 border-b border-white/10 pb-12 mb-8">
          {/* Brand */}
          <div className="flex-shrink-0">
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-10 h-10 flex items-center justify-center flex-shrink-0">
                <div className="absolute inset-0 bg-[#FFD93D] rounded-xl rotate-3" />
                <div className="absolute inset-0 bg-black rounded-xl -rotate-1" />
                <span
                  className="relative z-10 font-black text-[#FFD93D]"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '18px', letterSpacing: '-0.05em' }}
                >RD</span>
              </div>
              <div className="flex flex-col leading-none">
                <span
                  className="text-white font-black uppercase"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
                >REGENT</span>
                <span
                  className="text-[#FFD93D] font-black uppercase"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
                >DIGITAL</span>
              </div>
            </div>
            <p className="text-white/50 font-semibold text-sm leading-relaxed max-w-xs">
              IT company specialising in custom software development, IT consulting, and digital marketing solutions.
            </p>

          </div>

          {/* Address & Contact */}
          <div className="flex flex-col sm:flex-row gap-12 flex-1 lg:justify-end">
            <div>
              <h4
                className="text-[#FFD93D] font-black uppercase text-lg mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.1em' }}
              >
                REGISTERED ADDRESS
              </h4>
              <address className="not-italic text-white/60 font-semibold text-sm leading-loose">
                International House<br />
                55 Longsmith Street<br />
                Gloucester<br />
                GL1 2HT<br />
                United Kingdom
              </address>
            </div>

            <div>
              <h4
                className="text-[#FFD93D] font-black uppercase text-lg mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.1em' }}
              >
                CONTACT
              </h4>
              <div className="space-y-3">
                <a
                  href="tel:+447520657571"
                  className="flex items-center gap-2 text-white/60 hover:text-[#FFD93D] transition-colors cursor-pointer text-sm font-semibold"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-smartphone-line text-[#FFD93D]" />
                  </div>
                  +44 7520 657571
                </a>
                <a
                  href="mailto:support@regent-digital.com"
                  className="flex items-center gap-2 text-white/60 hover:text-[#FFD93D] transition-colors cursor-pointer text-sm font-semibold"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-[#FFD93D]" />
                  </div>
                  support@regent-digital.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 font-semibold text-sm">
            © 2026 Regent Digital LTD. All rights reserved. Registered in England & Wales.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/terms-of-use"
              className="text-white/40 hover:text-[#FFD93D] font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Terms of Use
            </Link>
            <Link
              to="/privacy-policy"
              className="text-white/40 hover:text-[#FFD93D] font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <Link
              to="/refund-policy"
              className="text-white/40 hover:text-[#FFD93D] font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
